<nav
  class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent"
  style="height: 62.45px"
>
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-toggle">
        <button type="button" class="navbar-toggler" (click)="sidebarToggle()">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <a style="text-decoration: none; font-weight: bold">
        <span class="d-none d-xl-block d-lg-block">
          Sorteo de Obras Viales y de Edificaciones en Distintas Provincias
          <span style="color: red" *ngIf="env.Staging"
            >AMBIENTE DE PRUEBA</span
          >
        </span>
      </a>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseExample"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div
      class="collapse navbar-collapse justify-content-end"
      id="collapseExample"
      [ngbCollapse]="isCollapsed"
    >
      <ul class="navbar-nav">
        <li
          class="nav-item btn-rotate"
          ngbDropdown
          placement="bottom-left"
          *ngIf="authenticationService.isAuthenticated()"
          style="cursor: pointer"
        >
          <a class="nav-link" ngbDropdownToggle id="navbarDropdownMenuLink">
            <i class="nc-icon nc-settings-gear-65"></i>
            <p>
              <span class="d-lg-none d-md-block"></span>
            </p>
          </a>
          <div
            ngbDropdownMenu
            aria-labelledby="navbarDropdownMenuLink"
            class="dropdown-menu dropdown-menu-right"
          >
            <a ngbDropdownItem (click)="authenticationService.signout()">
              Cerrar sesión
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
